import callApi from './storeMapService';

const basePath = '/frontend/api/v2/store';

export const getStoreDropdown = (formData) => callApi({
  method: 'GET',
  endpoint: `${basePath}/dropdown?${formData}`,
  body: formData
});
